import { useTheme } from "@hooks/useTheme";
import { useMemo } from "react";

const JsonViewer = ({ jsonData, "data-testid": dataTestId = "json-viewer" }) => {
  const { colors } = useTheme();

  const normalizedData = useMemo(() => {
    let parsed;
    try {
      parsed = typeof jsonData === "string" ? JSON.parse(jsonData) : jsonData;
    } catch (e) {
      console.error("Invalid JSON:", e);
      return {};
    }
    return parsed;
  }, [jsonData])

  return (
    <div
      className={`border rounded-lg ${colors.borderPrimary} ${colors.bgInput} p-4 whitespace-pre-wrap overflow-auto h-full`}
      style={{maxHeight: '400px'}}
      data-testid={dataTestId}
    >
        <pre className={`${colors.textMessage} text-sm p-2`} data-testid={`${dataTestId}-pre`}>
          {JSON.stringify(normalizedData, null, 2)}
        </pre>
    </div>
  )
}

export default JsonViewer